import React from 'react';
import styled from 'styled-components/native';
import { Platform, useWindowDimensions } from 'react-native';
import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { Feather } from '@expo/vector-icons';
import { H2, P } from '../../components/Typography';
import Colors from '../../constants/Colors';
import IconButton from '../../components/IconButton';
import { IntroNavigationControls } from './IntroAbout1Screen';

const StyledContainer = styled.View`
  background: ${Colors.secondarySand};
  flex: 1;
`;

const StyledScrollView = styled.ScrollView`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
`;

const StyledView = styled.View`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 0 20px;
`;

const StyledBackButtonContainer = styled.View`
  margin-top: 40px;
  margin-left: 20px;
`;

const StyledContent = styled.View<{ isMobile: boolean }>`
  max-width: ${p => (p.isMobile ? '100%' : '500px')};
`;

const StyledIconView = styled.View<{
  isMobileLandscape: boolean;
  isMobile: boolean;
}>`
  align-items: center;
  margin-top: ${p => (p.isMobileLandscape ? 30 : p.isMobile ? 90 : 60)}px;
  margin-bottom: ${p => (p.isMobileLandscape ? 30 : p.isMobile ? 90 : 60)}px; ;
`;

const StyledBackgroundImageView = styled.Image`
  width: 100%;
  height: 100%;
`;

const StyledIconImage = styled.Image`
  width: 300px;
  height: 195px;
`;

const StyledHeaderText = styled(H2)`
  font-size: 43px;
  line-height: 45px;
  letter-spacing: -0.17px;
  text-align: center;
`;

const StyledDefinitionText = styled(P)`
  font-size: 18px;
  letter-spacing: -0.09px;
  text-align: center;
  font-style: italic;
  font-weight: bold;
`;

const StyledInfoText = styled(P)`
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.11px;
  text-align: center;
  font-weight: bold;
`;

const StyledIconButton = styled(IconButton)`
  margin: 0 0 15px 0;
`;

const IntroAbout4Screen: React.FC = () => {
  const navigation = useNavigation<StackNavigationProp<any>>();
  const window = useWindowDimensions();
  const isMobileLandscape = Platform.OS !== 'web' && window.width >= 800;
  const isMobile = window.width < 500;
  return (
    <StyledContainer>
      <StyledBackgroundImageView
        resizeMode='cover'
        source={require('../../assets/intro/intro-background-whole.png')}
      />
      <StyledScrollView
        scrollIndicatorInsets={{ right: 1 }}
        contentContainerStyle={{
          flexGrow: 1,
          flexDirection: 'column',
          justifyContent: 'space-around'
        }}
      >
        {isMobile && (
          <StyledBackButtonContainer>
            <StyledIconButton
              onPress={() => {
                navigation.navigate('IntroAbout3Screen');
              }}
            >
              <Feather
                name='arrow-left'
                size={24}
                color={Colors.primaryPurple}
              />
            </StyledIconButton>
          </StyledBackButtonContainer>
        )}
        <StyledView>
          <StyledContent isMobile={isMobile}>
            {!isMobile && (
              <StyledIconButton
                onPress={() => {
                  navigation.navigate('IntroAbout3Screen');
                }}
              >
                <Feather
                  name='arrow-left'
                  size={24}
                  color={Colors.primaryPurple}
                />
              </StyledIconButton>
            )}
            <StyledHeaderText color='dark' padding={3.1}>
              Understand
            </StyledHeaderText>
            <StyledDefinitionText color='dark'>
              Know Yourself
            </StyledDefinitionText>
            <StyledIconView
              isMobileLandscape={isMobileLandscape}
              isMobile={isMobile}
            >
              <StyledIconImage
                source={require('../../assets/intro/intro-about-image-4.png')}
              />
            </StyledIconView>
            <StyledInfoText color='dark' padding={3}>
              Your results may surprise you. Chloe makes it easy to decide what
              to do next
            </StyledInfoText>
            <IntroNavigationControls
              onNext={() => navigation.navigate('IntroAbout5Screen')}
              onSkip={() => navigation.navigate('Intro')}
            />
          </StyledContent>
        </StyledView>
      </StyledScrollView>
    </StyledContainer>
  );
};

export default IntroAbout4Screen;
